import type { CodecRegistry } from 'v5/core/entity-values/values.types';
import { booleanCodec } from './boolean.codec';
import { contactDetailsCodec } from './contact-details.codec';
import { currencyCodec } from './currency.codec';
import { dateRangeCodec } from './date-range.codec';
import { dateCodec } from './date.codec';
import { dimensionCodec } from './dimension.codec';
import { entityRefCodec } from './entity-ref.codec';
import { groupsCodec } from './groups.codec';
import { heightCodec } from './height.codec';
import { locationCodec } from './location.codec';
import { measurementLegacyCodec } from './measurement-legacy.codec';
import { measurementCodec } from './measurement.codec';
import { multiSelectCodec } from './multi-select.codec';
import { nameCodec } from './name.codec';
import { netsuiteMasterProjectCodec } from './netsuite-master-project.codec';
import { numberCodec } from './number.codec';
import { percentageCodec } from './percentage.codec';
import { pronounsCodec } from './pronouns.codec';
import { rateCodec } from './rate.codec';
import { singleSelectCodec } from './single-select.codec';
import { tagsCodec } from './tags.codec';
import { textCodec } from './text.codec';
import { urlCodec } from './url.codec';

/** Closed map: adding a `FieldKind` fails to compile until its codec is here. */
export const resourceCodecs: CodecRegistry = {
  text: textCodec,
  boolean: booleanCodec,
  number: numberCodec,
  date: dateCodec,
  'date-range': dateRangeCodec,
  'single-select': singleSelectCodec,
  'multi-select': multiSelectCodec,
  measurement: measurementCodec,
  currency: currencyCodec,
  url: urlCodec,
  percentage: percentageCodec,
  height: heightCodec,
  dimension: dimensionCodec,
  'measurement-legacy': measurementLegacyCodec,
  'netsuite-master-project': netsuiteMasterProjectCodec,
  name: nameCodec,
  pronouns: pronounsCodec,
  'contact-details': contactDetailsCodec,
  tags: tagsCodec,
  groups: groupsCodec,
  location: locationCodec,
  rate: rateCodec,
  'entity-ref': entityRefCodec
};
